const prefix = '@retailMedia/industry/advertiserPublisher'

export const ADVERTISER_PUBLISHER_LIST = `${prefix}/LIST`

export const types = {
  list: ADVERTISER_PUBLISHER_LIST
}
